const map = {
	"./EBS.svg": 5598,
	"./Online Shopping-Shopping-Smartphone-Shopping Bag-Commerce.svg": 8015,
	"./avatar.svg": 6321,
	"./building.svg": 2050,
	"./burger-icon-black.svg": 3975,
	"./burger-icon.svg": 5129,
	"./data.svg": 2062,
	"./down-arrow.svg": 7810,
	"./left-arrow.svg": 2585,
	"./mobile-app.svg": 5946,
	"./product-release.svg": 8099,
	"./project3.svg": 5472,
	"./right-arrow.svg": 8036,
	"./rocket.svg": 1950,
	"./saas.svg": 3422,
	"./script.svg": 6899,
	"./ux-design.svg": 4336
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;